import { createSelector } from 'reselect';
import appliedPromotionsSelector from 'selectors/basket/appliedPromotions/appliedPromotionsSelector';
import Empty from 'constants/empty';

const SAMEDAY_COUPON_CODE = 'sameday';

const isSameDayCouponAppliedSelector = createSelector(appliedPromotionsSelector, appliedPromotions =>
    (appliedPromotions || Empty.Array).some(promo => promo?.couponCode?.toLowerCase() === SAMEDAY_COUPON_CODE)
);

export { isSameDayCouponAppliedSelector };
